function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
import difference from 'lodash/difference';
import deepEquals from "./deepEquals";
/**
 * Compares two objects and returns the names of the fields that have changed.
 * This function iterates over each field of object `a`, using `_.isEqual` to compare the field value
 * with the corresponding field value in object `b`. If the values are different, the field name will
 * be included in the returned array.
 *
 * @param {unknown} a - The first object, representing the original data to compare.
 * @param {unknown} b - The second object, representing the updated data to compare.
 * @returns {string[]} - An array of field names that have changed.
 *
 * @example
 * const a = { name: 'John', age: 30 };
 * const b = { name: 'John', age: 31 };
 * const changedFields = getChangedFields(a, b);
 * console.log(changedFields); // Output: ['age']
 */

export default function getChangedFields(a, b) {
  var aIsPlainObject = isPlainObject(a);
  var bIsPlainObject = isPlainObject(b); // If strictly equal or neither of them is a plainObject returns an empty array

  if (a === b || !aIsPlainObject && !bIsPlainObject) {
    return [];
  }

  if (aIsPlainObject && !bIsPlainObject) {
    return keys(a);
  } else if (!aIsPlainObject && bIsPlainObject) {
    return keys(b);
  } else {
    var unequalFields = keys(pickBy(a, function (value, key) {
      return !deepEquals(value, get(b, key));
    }));
    var diffFields = difference(keys(b), keys(a));
    return [].concat(_toConsumableArray(unequalFields), _toConsumableArray(diffFields));
  }
}